<template>
  <div class="sala-box" @mouseover="hover=true" @mouseout="hover=false">
    <img :src="'/images/CityPlan/ReviewConsultation/'+info.Image" />

    <transition name="karta-swap">
      <div v-if="hover" class="back-cover">
        <div class="text-overlay" :class="section">
          <span class="titleName" v-if="info.Title">{{info.Title}}</span>
          <hr />
          <span class="groupName">{{info.Summary}}</span>
        </div>
      </div>
    </transition>
  </div>
</template>	
<script>
export default {
  props: {
    info: {},
    section: ""
  },
  data() {
    return {
      hover: false
    };
  }
};
</script>
<style lang="scss">
.sala-box {
  position: relative;
  margin: 0 3px;
}
.sala-box .front-cover {
  position: absolute;
  bottom: 7px;
  right: 0;
  background: rgba(0, 0, 0, 0.3);
  color: #ccc;
  font-size: 0.8em;
  text-align: right;
  padding: 0.3em;
  padding-right: 1em;
}
.sala-box .back-cover {
  text-align: center;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 6px;
  width: 100%;
  /*height: 100%;*/
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  resize: both;
  overflow: auto;
}

.sala-box .text-overlay {
  background: rgba(23, 196, 238, 0.5);
  color: #fff;
  resize: both;
  overflow: auto;
  padding: 2em;
  width: 90%;
  border-radius: 3px;
  border-bottom-right-radius: 30px;

  &.economy {
    background: #3b61da;
  }
  &.community {
    background: #dd6311;
  }
  &.environment {
    background: #29a358;
  }
  &.placemaking {
    background: #e7b128;
  }
  &.leadership {
    background: #794fa0;
  }
}

@media screen and (max-width: 1216px) and (min-width: 769px) {
  .sala-box .text-overlay {
    font-size: 0.7em;
    width: 80%;
  }
}
.sala-box .text-overlay hr {
  margin: 0;
  margin-top: 0.5em;
  margin-bottom: 0.3em;
}

.sala-box .text-overlay .titleName {
  font-size: 2em;
  line-height: 1em;
  font-weight: bold;
  margin-bottom: 6px;
}
.sala-box .text-overlay .groupName {
}

.sala-box .text-overlay .venueTitle {
  font-size: 2.2em;
  font-weight: bold;
}
.sala-box .text-overlay .venue {
  font-size: 1.2em;
  font-weight: bold;
}

.sala-box .text-overlay .url {
  padding: 0.7em;
  margin-top: 0.5em;
  background: rgba(23, 196, 238, 0.8);
  font-size: 0.8em;
  font-weight: bold;
}
.sala-box .text-overlay .url a {
  color: #fff;
}
.sala-box .text-overlay .url a:hover {
  color: #333;
}

.sala-box img {
  transition: transform 0.3s;
}
.sala-box img:hover {
  -webkit-transform: scale(1.02);
  -ms-transform: scale(1.02);
  transform: scale(1.02);

  -webkit-transform: rotateZ(-1deg);
  -ms-transform: rotateZ(-1deg);
  transform: rotateZ(-1deg);
}

.karta-leave-active {
}
.karta-leave {
}
.karta-leave-to {
}

.karta-swap-enter-active {
  transition: all 0.4s cubic-bezier(1, 0, 0.8, 1);
}
.karta-swap-enter {
  transform: rotateX(90deg);
  opacity: 0;
}
.karta-swap-enter-to {
  top: 100%;
  position: relative;
  transition: all 0.3s ease-out;
  background: #428bca;
  height: 100%;
  opacity: 0.8;
}
</style>


// WEBPACK FOOTER //
// Modules/CityPlan/Resources/assets/js/components/CityPlanCard.vue